import { useQuery } from '@tanstack/react-query';
import { useApi } from '@/api/ApiContext';
import type { GetCategoryTreeResponse } from '@/api/handlers/resources/categories/responses';
import type { ApiResponse } from '@/api/handlers/responses';
import { CategoryQueryKeys } from './categoryQueryKeys';

/**
 * Reads the category hierarchy from `GET /categories/tree` (nested nodes).
 * Drives the Categories management table's expandable rows. When the planned
 * `categories/treeDetails` endpoint lands (same nested shape plus per-node
 * aggregates), only the `queryFn` here and the row mapper in `useCategoryTable`
 * need to change.
 */
export const useCategoryTreeQuery = (enabled = true) => {
    const { apiClient } = useApi();

    return useQuery<ApiResponse<GetCategoryTreeResponse>>({
        queryKey: CategoryQueryKeys.tree(),
        queryFn: () => apiClient.categories.getCategoryTree(),
        enabled,
        staleTime: 60_000,
    });
};
